import Button from "@helsenorge/designsystem-react/components/Button";
import Icon from "@helsenorge/designsystem-react/components/Icon";
import TrashCan from "@helsenorge/designsystem-react/components/Icons/TrashCan";
import { useNavigate } from "react-router-dom";
import { useGetResources } from "../../hooks/useGetResources";
import { useAppDispatch, useAppSelector } from "../../store/reducer";
import { deleteOppgave } from "../../store/thunks/thunk-oppgaveDetaljer";
import Modal from "@helsenorge/designsystem-react/components/Modal";
import React from "react";
import { OPPGAVER_PATH } from "HNEntities/url-types";
import { getSlettModalDescription } from "utils/details-utils";

export const DeleteOppgave = (): React.JSX.Element => {
  const resources = useGetResources();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const oppgave = useAppSelector((state) => state.oppgaveDetaljer.oppgave);

  const [showSlettModal, setShowSlettModal] = React.useState(false);

  const handleDelete = async (): Promise<void> => {
    if (!oppgave?.Id) {
      setShowSlettModal(false);
      return;
    }

    try {
      await dispatch(deleteOppgave(oppgave.Id)).unwrap();
      navigate(OPPGAVER_PATH);
    } catch (error) {
      console.error("Feil ved sletting av oppgave:", error);
    } finally {
      setShowSlettModal(false);
    }
  };

  return (
    <>
      <Button
        concept="destructive"
        variant="borderless"
        onClick={() => setShowSlettModal(true)}
      >
        <Icon svgIcon={TrashCan} />
        {resources?.knapp_slett || ""}
      </Button>
      {showSlettModal && (
        <Modal
          title={resources?.modal_slett_title || ""}
          description={getSlettModalDescription(oppgave, resources)}
          primaryButtonText={resources?.knapp_slett_2 || ""}
          secondaryButtonText={resources?.buttontext_cancel || ""}
          onSuccess={handleDelete}
          onClose={() => setShowSlettModal(false)}
        />
      )}
    </>
  );
};
